// Chromosome module to handle chromosome list
// To load fasta dictionary and cytobands

// Importing Helix modules
import FileReader from 'helix-modules/file';
import Memoize from 'helix-modules/memoize';
import 'helix-modules/sNumber';

export const chromosomes = [{
  label: '1',
  value: 1,
}, {
  label: '2',
  value: 2,
}, {
  label: '3',
  value: 3,
}, {
  label: '4',
  value: 4,
}, {
  label: '5',
  value: 5,
}, {
  label: '6',
  value: 6,
}, {
  label: '7',
  value: 7,
}, {
  label: '8',
  value: 8,
}, {
  label: '9',
  value: 9,
}, {
  label: '10',
  value: 10,
}, {
  label: '11',
  value: 11,
}, {
  label: '12',
  value: 12,
}, {
  label: '13',
  value: 13,
}, {
  label: '14',
  value: 14,
}, {
  label: '15',
  value: 15,
}, {
  label: '16',
  value: 16,
}, {
  label: '17',
  value: 17,
}, {
  label: '18',
  value: 18,
}, {
  label: '19',
  value: 19,
}, {
  label: '20',
  value: 20,
}, {
  label: '21',
  value: 21,
}, {
  label: '22',
  value: 22,
}, {
  label: 'X',
  value: 23,
}, {
  label: 'Y',
  value: 24,
}];

export class ChromosomeDictionary {
  static getCytoband({ chromosome, position }) {
    return (chromosome?.cytobands.find(
      ({ chromEnd, chromStart }) => position.isInBetween({
        edge: '[]',
        max: chromEnd,
        min: chromStart,
      })
    ))?.band;
  }

  static async load({ bandsUrl, dictUrl }) {
    const fasta = await (new FileReader({
      trimLines: 1,
      type: 'dict',
    })).parse({ url: dictUrl });

    // Load cytobands dict
    const cytobands = await (new FileReader({
      type: 'tsv',
    })).parse({ url: bandsUrl });
    // Mutate list to cast position to number
    cytobands.forEach((item) => {
      item.chromStart = Number(item.chromStart);
      item.chromEnd = Number(item.chromEnd);
    });

    // merging and set the complete dictionary for the chromosome lsit
    return ChromosomeDictionary.mergeCytoband(
      cytobands,
      ChromosomeDictionary.mergeFastaDict(fasta),
    );
  }

  /**
   * Helper to merge fasta dict content with chromosome list
   * @param {array} fasta dict content chr/length
   * @return {array} list of chromosome with length from fasta dict
  **/
  static mergeFastaDict(dict) {
    return chromosomes.map((chromosome) => {
      const chr = dict.find((chr) => chr.label === chromosome.label);
      return {
        ...chromosome,
        ...chr,
      };
    });
  }

  /**
   * Helper to inject cytoband list to chromosome list
   * @param {array} cytobands list
   * @return {array} mutate orginal chromosome list
  **/
  static mergeCytoband(cytobands, org) {
    org = org || chromosomes;
    org.forEach((chromosome) => {
      chromosome.cytobands = cytobands.filter((band) => band.chrom === chromosome.label);
    });
    return org;
  }
}

export const MChromosomeDictionary = Memoize(ChromosomeDictionary, [{
  name: 'load',
  keygen: (name, args = []) => `${name}_${args[0]?.bandsUrl ?? ''}_${args[0]?.dictUrl ?? ''}`,
}]);
